import { render, staticRenderFns } from "./AppointmentConfigList.vue?vue&type=template&id=5a3b3003&"
import script from "./AppointmentConfigList.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports